export default __webpack_public_path__ + "static/media/logo.09b3c7a3.svg";